import { getDefaultExportFromCjs } from "./_commonjsHelpers.js";
import { __require as requireSemver } from './../_node_modules/semver/index.js';
var semverExports = requireSemver();
const semver = /* @__PURE__ */ getDefaultExportFromCjs(semverExports);
export {
  semver as default
};
//# sourceMappingURL=index.js.map
